import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Space} from 'antd';
import {StyledPolicies} from './StyledPolicies';
import Spin from '../../../../Spin';
import PolicyEditorWithPreview from '../../tabComponents/PolicyEditorWithPreview';
import {useFeatureAvailable} from '../../../../../hooks';
import {agentActions} from '../../../../../state/actions/agent.actions';
import {alertActions} from '../../../../../state/actions/alert.actions';
import {companyFeaturesConstants} from '../../../../../constants';

const policyKeys = {
  expense_policy: 'expense_policy',
  approval_policy: 'approval_policy',
}

const {approval_policy, expense_policy} = policyKeys;

const Policies = ({
  dispatch,
  createCompanyPolicy,
  getCompanyPolicies,
  updateCompanyPolicy,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'settings']);
  const [policy, setPolicy] = React.useState(null);
  const [loading, setLoading] = React.useState({
    [approval_policy]: true,
    [expense_policy]: true
  });

  const isEnableEdit = useFeatureAvailable(companyFeaturesConstants.USE_CUSTOM_POLICIES);

  const finishLoading = () => setLoading({[approval_policy]: false, [expense_policy]: false});

  useEffect(() => {
    getCompanyPolicies({
      successCallback: (resp) => {
        const policy = resp?.results?.[0] || undefined;
        if (policy) setPolicy(policy);
        finishLoading();
      },
      errorCallback: finishLoading,
    })
  }, [getCompanyPolicies]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpdatePolicy = ({key, value, successCallback}) => {
    const id = policy?.id || null;
    let data = {[key]: value};
    if (!id) {
      // Add all other policy keys with empty string if creating new
      Object.keys(policyKeys).forEach(k => {
        if (k !== key) data[k] = '';
      });
    }
    const action = id ? updateCompanyPolicy : createCompanyPolicy;

    setLoading({...loading, [key]: true});
    action({
      ...(id ? {id} : {}),
      data,
      successCallback: (resp) => {
        setPolicy(resp);
        finishLoading();
        successCallback?.(resp);
      },
      errorCallback: () => {
        finishLoading();
        alertActions.error(t('settings:validation.failedToUpdatePolicy'));
      },
    });
  }

  const tabT = (key) => t(`settings:tabs.expenses.items.${key}`);

  const policies = [
    {key: expense_policy},
    {alert: true, key: approval_policy}
  ];

  return (
    <StyledPolicies
      {...rest}
    >
      <Space style={{ width: '100%' }} size='middle' direction='vertical'>
        {policies.map(({alert, key}) => (
          <Spin key={key} spinning={loading[key]} size='small'>
            <PolicyEditorWithPreview
              alert={alert && tabT(`${key}.alert`)}
              enableEdit={isEnableEdit}
              defaultValue={policy?.[key] || ''}
              empty={tabT(`${key}.empty`)}
              title={tabT(`${key}.title`)}
              onSave={(props) => handleUpdatePolicy({key, ...props})}
            />
          </Spin>
        ))}
      </Space>
    </StyledPolicies>
  );
}

const mapDispatchToProps = {
  createCompanyPolicy: agentActions.createCompanyPolicy,
  getCompanyPolicies: agentActions.getCompanyPolicies,
  updateCompanyPolicy: agentActions.updateCompanyPolicy,
}

export default connect(null, mapDispatchToProps)(Policies);
